import { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import advancedAnalytics from '../../services/advancedAnalytics';

/**
 * StandaloneAuthGate - Authentication guard for standalone pages
 * 
 * This component ensures authentication for standalone pages (like PixieDustAnimationPage
 * and ItineraryView) without wrapping them in AgentShell or AdminShell.
 * 
 * Unlike ProtectedRoute, this does NOT enforce role-based access (admin/special access).
 * It only ensures the user is authenticated.
 * 
 * Usage:
 *   <Route 
 *     path="/agent/pixie-dust-animation" 
 *     element={<StandaloneAuthGate><PixieDustAnimationPage /></StandaloneAuthGate>} 
 *   />
 */
const StandaloneAuthGate = ({ children }) => {
  const context = useContext(UserContext) || {};
  const { user, loadingUser } = context;

  useEffect(() => {
    if (user) {
      advancedAnalytics.setUserContext(user);
    }
  }, [user]);

  if (loadingUser) {
    return (
      <div className="flex justify-center items-center min-h-screen text-xl text-white">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/agent/login" replace />;
  }

  return children;
};

export default StandaloneAuthGate;
